import { render, staticRenderFns } from "./seturl.vue?vue&type=template&id=a0ca4bf8&scoped=true"
import script from "./seturl.vue?vue&type=script&lang=js"
export * from "./seturl.vue?vue&type=script&lang=js"
import style0 from "./seturl.vue?vue&type=style&index=0&id=a0ca4bf8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a0ca4bf8",
  null
  
)

export default component.exports